"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
require("core-js/modules/es.array.includes.js");
var _button = _interopRequireDefault(require("../button"));
var _lottie = _interopRequireDefault(require("../lottie"));
var infoMap = {
  'general': '内容为空',
  'network-data': '没有网络',
  'data': '有网无数据',
  'message': '消息为空',
  'red-envelope': '红包为空',
  '18': '未满18岁',
  'want-treasure': '没有失效宝贝哦，看看推荐商品吧~',
  'order': '没有帮卖订单，快把尘封的设备转起来吧~',
  'help-order': '竟然一个能卖的宝贝都没有',
  'footprint': '快去逛逛添加喜欢的商品吧'
};
var lottieMap = {
  'general': 'https://s1.zhuanstatic.com/common/open/zzui_lottie_general.json',
  'network-data': 'https://s1.zhuanstatic.com/common/open/zzui_lottie_network-data.json',
  'data': 'https://s1.zhuanstatic.com/common/open/zzui_lottie_data.json',
  'message': 'https://s1.zhuanstatic.com/common/open/zzui_lottie_message.json',
  'red-envelope': 'https://s1.zhuanstatic.com/common/open/zzui_lottie_red-envelope.json',
  '18': 'https://s1.zhuanstatic.com/common/open/zzui_lottie_18.json'
};
var _default2 = {
  render: function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('div', {
      staticClass: "z-stance"
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.imgSrc,
        expression: "imgSrc"
      }],
      staticClass: "z-stance__img",
      attrs: {
        "src": _vm.imgSrc,
        "onerror": _vm.defaultImgEro
      }
    }), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.isLottie && !_vm.imgSrc,
        expression: "isLottie && !imgSrc"
      }],
      staticClass: "z-stance__lottie"
    }, [_c('z-lottie', {
      attrs: {
        "options": {
          path: _vm.lottieMap[this.type]
        },
        "height": "150",
        "width": "150"
      }
    })], 1), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: !_vm.isLottie && !_vm.imgSrc,
        expression: "!isLottie && !imgSrc"
      }],
      class: _vm.imgClass
    }), _vm.infoText && _vm.showInfo ? _c('p', {
      staticClass: "z-stance__info",
      domProps: {
        "innerHTML": _vm._s(_vm.infoText)
      }
    }) : _vm._e(), _vm.descText ? _c('p', {
      staticClass: "z-stance__desc",
      domProps: {
        "innerHTML": _vm._s(_vm.descText)
      }
    }) : _vm._e(), _vm.showBtn && !_vm.$slots.btn ? _c('z-button', {
      attrs: {
        "type": _vm.btnType,
        "v9": "",
        "size": "small-detail",
        "btn-class": "z-stance__btn"
      },
      on: {
        "click": _vm.btnClick
      }
    }, [_vm._v("\n    " + _vm._s(_vm.btnText) + "\n  ")]) : _vm._e(), _vm.$slots.btn ? _vm._t("btn") : _vm._e()], 2);
  },
  name: 'z-stance',
  components: {
    'z-button': _button.default,
    'z-lottie': _lottie.default
  },
  props: {
    type: {
      type: String,
      default: 'general'
    },
    info: String,
    imgSrc: String,
    showBtn: {
      type: Boolean,
      default: function _default() {
        return this.type === 'network-data' || this.type === 'data';
      }
    },
    btnType: String,
    showInfo: {
      type: Boolean,
      default: true
    },
    btnText: {
      type: String,
      default: '点击刷新'
    },
    descText: String
  },
  data: function data() {
    return {
      defaultImgEro: 'this.src="https://img1.zhuanstatic.com/common/trade/img/message.png"',
      lottieMap: lottieMap
    };
  },
  computed: {
    infoText: function infoText() {
      return !this.info ? infoMap[this.type] : this.info;
    },
    imgClass: function imgClass() {
      return "z-stance__img--" + this.type + " z-stance__img";
    },
    isLottie: function isLottie() {
      return ['general', 'network-data', 'data', 'message', 'red-envelope', '18'].includes(this.type);
    }
  },
  methods: {
    btnClick: function btnClick() {
      this.$emit('click');
    }
  }
};
exports.default = _default2;